import { makeStyles } from "tss-react/mui";

export const useViewAllButtonStyles = makeStyles()(theme => ({
  root: {
    width: 120,
  },
}));
